if (!Shopify.formatMoney) {
  Shopify.money_format = '${{amount}}'
  Shopify.formatMoney = function (cents, format) {
    var value = '',
      placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
      formatString = format || window.__GLOBAL__.money_format

    if (typeof cents == 'string') {
      cents = cents.replace('.', '')
    }

    function defaultOption(opt, def) {
      return typeof opt == 'undefined' ? def : opt
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2)
      thousands = defaultOption(thousands, ',')
      decimal = defaultOption(decimal, '.')

      if (isNaN(number) || number == null) {
        return 0
      }

      number = (number / 100.0).toFixed(precision)

      var parts = number.split('.'),
        dollars = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          '$1' + thousands
        ),
        cents = parts[1] ? decimal + parts[1] : ''

      return dollars + cents
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2)
        break
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0)
        break
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',')
        break
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',')
        break
    }

    return formatString.replace(placeholderRegex, value)
  }
}

/* Product Tile Markup - You can play around with this to change the
information that appears on the Wishlisted Product tiles  */
const productCardMarkup = `<div class="custom-swym-wishlist-grid">
    {{#products}}
    <div class="swym-wishlist-item">
      <button id="swym-remove-productBtn" data-product-url="{{du}}" aria-label="Delete" data-list-id="{{lid}}" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button">
        <span class="swym-icon">
        </span>
      </button>
      <a href="{{du}}/?variant={{epi}}&quantity={{qty}}" aria-label="{{dt}}" class="swym-is-anchor">
        <div class="swym-wishlist-image-wrapper">
          <img alt="" class="swym-wishlist-image" src="{{iu}}">
        </div>
        <p class="swym-brand-name">
          {{bt}}
        </p>
        <p class="swym-title">
          {{dt}}
        </p>
        <p class="swym-variant">
          {{variantinfo}}
        </p>
        <div class="swym-product-price swym-text swym-text-1">
          <div class="swym-product-final-price swym-value">
            {{#isComingSoon}} {{cu}}TBD {{/isComingSoon}}
            {{^isComingSoon}} {{cu}}{{pr}} {{/isComingSoon}}
            - ({{qty}})
          </div>
        </div>
      </a>
    </div>
    {{/products}}
  </div>`

function getVariantInfo(variants) {
  try {
    let variantKeys =
        variants && variants != '[]'
          ? Object.keys(JSON.parse(variants)[0])
          : [],
      variantinfo
    if (variantKeys.length > 0) {
      variantinfo = variantKeys[0]
      if (variantinfo == 'Default Title') {
        variantinfo = ''
      }
    } else {
      variantinfo = ''
    }
    return variantinfo
  } catch (err) {
    return variants
  }
}

function onAddToCartClick(e) {
  e.preventDefault()
  const productId = e.currentTarget.getAttribute('data-product-id')
  const variantId = e.currentTarget.getAttribute('data-variant-id')
  const du = e.target.getAttribute('data-product-url')
  e.target.innerHTML = 'Adding..'
  window._swat.replayAddToCart(
    {
      empi: productId,
      du: du,
    },
    variantId,
    function (c) {
      e.target.innerHTML = 'Added to Cart'
      e.target.setAttribute('data-state-cart', 'swym-added')
      console.log('Successfully added product to cart.', c)
    },
    function (e) {
      console.log(e)
    }
  )
}

const trapFocus = (element) => {
  const parentElement = document.querySelector(element)
  const focusableEls = parentElement.querySelectorAll(
    'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])'
  )
  const firstFocusableEl = focusableEls[0]
  firstFocusableEl.focus()
  const lastFocusableEl = focusableEls[focusableEls.length - 1]
  const KEYCODE_TAB = 9

  parentElement.addEventListener('keydown', function (e) {
    var isTabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB

    if (!isTabPressed) {
      return
    }

    if (e.shiftKey) {
      /* shift + tab */ if (document.activeElement === firstFocusableEl) {
        lastFocusableEl.focus()
        e.preventDefault()
      }
    } /* tab */ else {
      if (document.activeElement === lastFocusableEl) {
        firstFocusableEl.focus()
        e.preventDefault()
      }
    }
  })
}

const getAllLists = async () => {
  const _lists = new Promise((resolve, reject) => {
    window._swat.fetchLists({
      callbackFn: function (lists) {
        resolve(lists)
      },
      errorFn: function (xhrObj) {
        reject(xhrObj)
      },
    })
  })

  const _auth = new Promise((resolve) => {
    window._swat.authCheck(function (shopperContext) {
      resolve(shopperContext)
    })
  })

  try {
    const auth = await _auth
    const lists = await _lists

    return auth.authn
      ? lists.filter((list) => list.userinfo.em === auth.email)
      : lists
  } catch (err) {
    console.error('error', err)
  }
}

const getAllWishlistedProduct = async () => {
  const allLists = await getAllLists()

  const allWishlistedProducts = allLists
    .filter((list) => list.listcontents && list.listcontents.length)
    .flatMap((list) => list.listContents.content)

  return allWishlistedProducts
}

const fetchListProducts = (lid) => {
  return new Promise((resolve) => {
    window._swat.fetchListCtx({ lid }, function (r) {
      resolve(r)
    })
  })
}

const fetchListDetail = (listID) => {
  return listID.length > 0
    ? new Promise((resolve) => {
        window._swat.fetchListDetails({ lid: listID }, function (r) {
          resolve(r)
        })
      })
    : {}
}

const getAllWishlistedProductsInList = async (listID) => {
  const products = await fetchListProducts(listID)
  return products
}

function onRemoveBtnClick(e) {
  e.preventDefault()
  const epi = +e.currentTarget.getAttribute('data-variant-id')
  const empi = +e.currentTarget.getAttribute('data-product-id')
  const lid = e.currentTarget.getAttribute('data-list-id')
  const du = e.currentTarget.getAttribute('data-product-url')

  const listItemMap = {
    epi: epi, // unique epi per listid
    empi: empi,
    du: du,
  }

  window._swat.deleteFromList(
    lid,
    listItemMap,
    function (deletedListItem) {
      // successfully deleted list item
      if (!window.SwymCallbacks) {
        window.SwymCallbacks = []
      }
      window.SwymCallbacks.push(swymRenderWishlist)
    },
    function (xhrObj) {
      console.log(xhrObj)
    }
  )
}

async function swymRenderWishlist(
  swat,
  reRender = false,
  fromSharedWishlist = false,
  sharedListID = '',
  page = false
) {
  const selectedWishlist = document.querySelector('#selectedWishlist')
  trapFocus('#ProductModalWishlistLists')

  if (page && fromSharedWishlist) {
    renderPageWishlistProducts(
      window._swat,
      sharedListID,
      '',
      fromSharedWishlist
    )
    return
  } else if (fromSharedWishlist) {
    renderWishlistProducts(window._swat, sharedListID, '', fromSharedWishlist)

    return
  }

  const allLists = await getAllLists()
  const notificationView = document.getElementById('openWl')
  const notifListID = notificationView
    ? notificationView.getAttribute('data-list-id')
    : ''
  const notifListName = notificationView
    ? notificationView.getAttribute('data-list-name')
    : ''
  const viewFromNotification = Boolean(notificationView)

  // get all list of wishlist and append to element
  const elListsOption = document.querySelector('#Wishlists')
  if (!allLists.length) {
    document
      .querySelector('#ProductModalWishlistLists')
      .classList.add('is-list-empty')
    document.querySelector('#wishlist-items-container').innerHTML = ''
  } else {
    document
      .querySelector('#ProductModalWishlistLists')
      .classList.remove('is-list-empty')
  }

  if (!elListsOption.children.length) {
    if (allLists.length > 1) {
      allLists.forEach((list) => {
        elListsOption.innerHTML += `<li data-list-id="${list.lid}">${list.lname}</li>`
      })
    }

    const svgElement = selectedWishlist.querySelector('svg')
    if (svgElement) {
      svgElement.style.display = allLists.length > 1 ? 'block' : 'none'
    }
    const wishlistContentsContainer = document.getElementById(
      'wishlist-items-container'
    )
    if (wishlistContentsContainer) {
      initClickListeners(reRender)
    }
  }

  if (viewFromNotification) {
    renderWishlistProducts(window._swat, notifListID, notifListName)
    return
  }

  if (allLists.length > 0) {
    renderWishlistProducts(window._swat, allLists[0].lid, allLists[0].lname)
  } else {
    renderWishlistProducts(window._swat, '', '')
  }
}

const closeWishlistListsModal = (e) => {
  if (e.getAttribute('from-shared-wishlist') !== null) {
    window.location.href = window.location.href.split('?')[0].split('#')[0]

    return
  }

  // Check if
  $('#ProductModalWishlistLists').attr('data-status', 'close')
  $('#ProductModalWishlistLists #wishlist-items-container').empty()
  $('body').removeClass('wishlist-modal-opened')
}

const isSafari = () => {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
}

const shareTo = (e, listID, lname, clipboard = false) => {
  if (clipboard) {
    const clipboardShare = document.querySelector('#wishlistCopyShare')
    const errorElement = document.querySelector('.clipboard-error')
    window._swat.generateSharedListURL(
      listID,
      function (data, sharedListId) {
        if (!isSafari() && navigator.clipboard) {
          navigator.clipboard.writeText(data)
          clipboardShare.classList.add('copied')
          setTimeout(function () {
            clipboardShare.classList.remove('copied')
          }, 2000)
        } else {
          const errorMessage =
            'Your browser does not support this function, this is the url of your wish list: '
          errorElement.innerHTML = `${errorMessage}<br/>${data}`
        }
      },
      function (data) {
        console.log(data)
      }
    )
    return
  }
  const sharers = window._swat.retailerSettings.Wishlist.SharingModes
  const getPlatform = e.getAttribute('data-share-platform')

  sharers.forEach((share) => {
    if (share.type !== getPlatform) return

    window._swat.shareListSocial(
      listID,
      lname,
      share.url,
      getPlatform,
      lname,
      function (data) {
        console.log(data)
      }
    )
  })
}

const renderSharerPlatform = (listID, lname) => {
  const elWishlistSharer = document.querySelector('#wishlistSharer')
  elWishlistSharer.innerHTML = ''
  const sharers = window._swat.retailerSettings.Wishlist.SharingModes
  const clipboardShare = document.querySelector('#wishlistCopyShare')

  sharers.forEach((share) => {
    elWishlistSharer.innerHTML += `<a class="icon-${share.type}" onclick="shareTo(this, '${listID}', '${lname}')" href="javascript:void(0);" data-share-url="${share.url}" data-share-platform="${share.type}"></a>`
  })

  clipboardShare.addEventListener('click', function () {
    shareTo('', listID, lname, (clipboard = true))
  })
  clipboardShare.querySelector('img').addEventListener('keyup', function (e) {
    if (e.key === 'Enter' || e.keyCode === 13) {
      shareTo('', listID, lname, (clipboard = true))
    }
  })
}

const renderAddAllProducts = (products) => {
  const addAllBTN = document.querySelector('.modify-wishlist__modal--add-all')
  if (!addAllBTN) return

  const addAllWrapper = document.getElementById('section-footer--cta')
  if (products.length > 0) {
    addAllBTN.setAttribute(
      'data-products-id',
      products.map((product) => product.epi).join(',')
    )
    addAllBTN.setAttribute(
      'data-products-qty',
      products.map((product) => product.qty).join(',')
    )
    addAllWrapper.style.display = 'flex'
  } else {
    addAllBTN.removeAttribute('data-products-id')
    addAllBTN.removeAttribute('data-products-qty')
    addAllWrapper.style.display = 'none'
  }

  addAllBTN.addEventListener('click', function () {
    addAllBTN.setAttribute('disabled', '')
    addProductsToCart(addAllBTN)
  })
}

const addProductsToCart = (btn) => {
  const attrIds = btn.getAttribute('data-products-id')
  const attrQty = btn.getAttribute('data-products-qty')
  const ids = attrIds.split(',')
  const qtys = attrQty.split(',')

  if (ids.length !== qtys.length) return

  const currentCopy = btn.innerHTML
  btn.innerHTML = 'Adding...'

  $.getJSON('/cart.js', function (cart) {
    ids.forEach(function (id, index) {
      var qty = parseInt(qtys[index], 10)

      var item = cart.items.find((item) => item.id === id)

      if (item) {
        item.quantity += qty
      } else {
        cart.items.push({ id: id, quantity: qty })
      }
    })

    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: {
        sections: 'mini-cart,header',
        updates: cart.items.reduce(
          (updates, item) =>
            Object.assign(updates, { [item.id]: item.quantity }),
          {}
        ),
      },
      dataType: 'json',
      success: function (response) {
        const closeButton = document.querySelector(
          '.wishlist-lists-modal-close-btn'
        )
        if (closeButton) {
          closeButton.click()
        }

        if (btn.getAttribute('data-redirect-to-checkout')) {
          window.location.href = '/checkout'
        } else {
          window.Shopify.reRenderShopifySections(response, '[data-rerender]')
          setTimeout(() => {
            const iconBTN = document.querySelector('.header--mini-cart')
            if (iconBTN) {
              iconBTN.shadowRoot.querySelector('a').click()
            }
          }, 0)
        }
      },
      error: function (jqXHR, textStatus, errorThrown) {
        console.error('Error while adding products to the cart')
        console.error('Error status: ' + textStatus)
        console.error('Error message: ' + errorThrown)
        if (jqXHR.responseJSON) {
          console.error('Error details: ', jqXHR.responseJSON)
        }
      },
      complete: function () {
        btn.removeAttribute('disabled')
        btn.innerHTML = currentCopy
      },
    })
  })
}

const renderHeader = (
  products,
  listID,
  lname,
  fromSharedWishlist,
  sharedWishlistInfo = {}
) => {
  const elWishlistTotal = document.querySelector('#WishlistTotal h2')

  const isAllProductsComingSoon = !products.some((product) => {
    return !product.cprops?.tags?.includes('Coming Soon')
  })

  const listTotal = products
    .map((product) => {
      return product.qty * Number(product.pr)
    })
    .reduce((a, b) => a + b, 0)

  const priceWithCurrent = Shopify.formatMoney(listTotal * 100)
  elWishlistTotal.innerText = isAllProductsComingSoon
    ? Shopify.money_format.replace('{{amount}}', 'TBD')
    : priceWithCurrent

  const elSelectedList = document.querySelector('#selectedWishlist')
  const elSelectedListTitle = document.querySelector(
    '#selectedWishlist h1 .section-header__title'
  )
  const elSelectedListQty = document.querySelector(
    '#selectedWishlist h1 .section-header__qty'
  )

  elSelectedList.setAttribute('data-list-id-shown', listID)
  elSelectedList.setAttribute('data-list-name-shown', lname)
  elSelectedListTitle.innerText = lname
  elSelectedListQty.innerText = ` (${products.length})`

  if (fromSharedWishlist) {
    renderSharedWishlist(elSelectedList, sharedWishlistInfo)
  }

  renderSharerPlatform(listID, lname)

  renderAddAllProducts(products)
}

const renderWishlistProducts = async (
  swat,
  listID = '',
  lname = '',
  fromSharedWishlist = false
) => {
  const parentWrapper = document.getElementById('ProductModalWishlistLists')
  const wishlistContentsContainer = parentWrapper.querySelector(
    '#wishlist-items-container'
  )
  let products = []

  if (listID.length > 0) {
    products = await getAllWishlistedProductsInList(listID)
  }
  const listDetail = await fetchListDetail(listID)

  renderHeader(
    products,
    listID,
    fromSharedWishlist ? listDetail?.list?.lname : lname,
    fromSharedWishlist,
    (sharedWishlistInfo = listDetail?.list)
  )
  wishlistContentsContainer.innerHTML = ''

  const modalContentWrapper = parentWrapper.querySelector(
    '.wishlist-items-container--wrapper'
  )
  if (products.length === 0) {
    modalContentWrapper.classList.add('is-empty')
    return
  }

  modalContentWrapper.classList.remove('is-empty')

  const formattedWishlistedProducts = products.map(function (p) {
    p = SwymUtils.formatProductPrice(p) // formats product price and adds currency to product Object
    p.isInCart =
      _swat.platform.isInDeviceCart(p.epi) || p.et == _swat.EventTypes.addToCart
    p.variantinfo = p.vi ? getVariantInfo(p.vi) : ''
    p.qty = typeof p.qty === 'undefined' ? 1 : p.qty
    p.lid = p.lid
    p.bt = p.bt
    p.tags = p.cprops?.tags || []

    const isComingSoon = p.cprops?.tags.findIndex(
      (tag) => tag.toLowerCase() === 'coming soon'
    )
    p.isComingSoon = isComingSoon > -1

    return p
  })

  const productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
    products: formattedWishlistedProducts,
  })

  if (wishlistContentsContainer) {
    wishlistContentsContainer.innerHTML = productCardsMarkup
    attachClickListeners()
  }

  if (fromSharedWishlist) {
    const wishlistGrid = wishlistContentsContainer.querySelectorAll(
      '.swym-wishlist-item'
    )
    wishlistGrid.forEach((grid) => {
      const wishlistGridButton = grid.querySelector('#swym-remove-productBtn')
      wishlistGridButton.remove()
    })

    const closeButton = parentWrapper.querySelector(
      '.wishlist-lists-modal-close-btn'
    )
    closeButton.setAttribute('from-shared-wishlist', true)
  }
}

const renderPageHeader = (
  products,
  listID,
  lname,
  fromSharedWishlist = true,
  sharedWishlistInfo = {}
) => {
  const parentSharedWishlist = document.getElementById('sharedWishlistPage')
  const elWishlistTotal =
    parentSharedWishlist.querySelector('#WishlistTotal h2')

  const listTotal = products
    .map((product) => {
      return product.qty * Number(product.pr)
    })
    .reduce((a, b) => a + b, 0)

  const priceWithCurrent = Shopify.formatMoney(listTotal * 100)
  elWishlistTotal.innerText = priceWithCurrent

  const elSelectedList = parentSharedWishlist.querySelector('#selectedWishlist')
  const elSelectedListTitle = parentSharedWishlist.querySelector(
    '#selectedWishlist h1 .section-header__title'
  )
  const elSelectedListQty = parentSharedWishlist.querySelector(
    '#selectedWishlist h1 .section-header__qty'
  )

  elSelectedList.setAttribute('data-list-id-shown', listID)
  elSelectedList.setAttribute('data-list-name-shown', lname)
  elSelectedListTitle.innerText = lname
  elSelectedListQty.innerText = ` (${products.length})`

  if (fromSharedWishlist) {
    renderSharedWishlist(elSelectedList, sharedWishlistInfo)
  }

  renderSharerPlatform(listID, lname)
}

const renderSharedWishlist = (elToAppend, sharedWishlistInfo) => {
  let div = document.createElement('div')
  div.classList.add('section-header__user')
  div.innerHTML = sharedWishlistInfo.userinfo
    ? `Wishlist created by: <br/> ${sharedWishlistInfo.userinfo.fname} ${sharedWishlistInfo.userinfo.lname} (${sharedWishlistInfo.userinfo.em})`
    : 'Wishlist created anonymously'

  elToAppend.append(div)
}

const renderPageWishlistProducts = async (
  swat,
  listID = '',
  lname = '',
  fromSharedWishlist = false
) => {
  const parentSharedWishlist = document.getElementById('sharedWishlistPage')
  const products = await getAllWishlistedProductsInList(listID)
  const listDetail = await fetchListDetail(listID)

  const wishlistContentsContainer = parentSharedWishlist.querySelector(
    '#wishlist-items-container'
  )
  renderPageHeader(
    products,
    listID,
    fromSharedWishlist ? listDetail?.list?.lname : lname,
    fromSharedWishlist,
    (sharedWishlistInfo = listDetail?.list),
    (page = true)
  )
  wishlistContentsContainer.innerHTML = ''

  const modalContentWrapper = parentSharedWishlist.querySelector(
    '.wishlist-items-container--wrapper'
  )
  if (products.length === 0) {
    modalContentWrapper.classList.add('is-empty')
    return
  }

  modalContentWrapper.classList.remove('is-empty')

  const formattedWishlistedProducts = products.map(function (p) {
    p = SwymUtils.formatProductPrice(p) // formats product price and adds currency to product Object
    p.isInCart =
      _swat.platform.isInDeviceCart(p.epi) || p.et == _swat.EventTypes.addToCart
    p.variantinfo = p.vi ? getVariantInfo(p.vi) : ''
    p.qty = typeof p.qty === 'undefined' ? 1 : p.qty
    p.lid = p.lid
    p.bt = p.bt
    return p
  })
  const productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
    products: formattedWishlistedProducts,
  })

  if (wishlistContentsContainer) {
    wishlistContentsContainer.innerHTML = productCardsMarkup
    attachClickListeners()
  }

  const wishlistGrid = wishlistContentsContainer.querySelectorAll(
    '.swym-wishlist-item'
  )
  wishlistGrid.forEach((grid) => {
    const wishlistGridButton = grid.querySelector('#swym-remove-productBtn')
    wishlistGridButton.remove()
  })
}

const initModifyListActions = (wishlistID, wishlistName) => {
  const saveButton = document.getElementById('saveEditList')
  const deleteButton = document.getElementById('deleteList')

  deleteButton.addEventListener('click', () => {
    window._swat.deleteList(
      wishlistID,
      function (deletedListObj) {
        // successfully deleted list
        const elNotify = document.querySelector('#modifyStatus')
        elNotify.innerHTML = `List <strong>${deletedListObj.lname}</strong> has been deleted <br> Pop up will be closed`
        console.log(
          'Deleted list with listid',
          `${deletedListObj.lid}: ${deletedListObj.lname}`
        )
        const elListsOption = document.querySelector('#Wishlists')
        elListsOption.innerHTML = ''
        deleteButton.setAttribute('disabled', '')

        setTimeout(() => {
          renderModifyModal((modalOpen = false))
          swymRenderWishlist(window._swat, (reRender = true))
        }, 2000)
      },
      function (xhrObject) {
        console.log(xhrObject)
      }
    )
  })
}

const deleteList = (wishlistID) => {
  window._swat.deleteList(
    wishlistID,
    function (deletedListObj) {
      // successfully deleted list
      const elNotify = document.querySelector('#removeList')
      elNotify.innerHTML = 'Removing...'
      const elListsOption = document.querySelector('#Wishlists')
      elListsOption.innerHTML = ''

      setTimeout(() => {
        elNotify.innerHTML = 'Removed'
        swymRenderWishlist(window._swat, (reRender = true))
      }, 1000)
    },
    function (xhrObject) {
      console.log(xhrObject)
    }
  )
}

const renderModifyModal = (modalOpen) => {
  const modifyModal = document.querySelector('#modifyWishlist')
  if (!modalOpen) {
    const elNotify = document.querySelector('#modifyStatus')
    elNotify.innerHTML = ''
    modifyModal.style.display = 'none'
    return
  }

  modifyModal.style.display = 'flex'
  const selectedWishlist = document.querySelector('#selectedWishlist')
  const wishlistID = selectedWishlist.getAttribute('data-list-id-shown')
  const wishlistName = selectedWishlist.getAttribute('data-list-name-shown')
  const deleteButton = document.getElementById('deleteList')

  const modifyInput = document.querySelector('.input-wishlist-name')
  modifyInput.innerHTML = `Are you sure you want to delete list <strong>${wishlistName}</strong>?`

  deleteButton.removeAttribute('disabled')
  initModifyListActions(wishlistID, wishlistName)
}

function attachClickListeners() {
  const addToCartButtons = document.querySelectorAll(
    '#swym-custom-add-toCartBtn'
  )
  const redirectButton = document.querySelectorAll('#swym-custom-add-toCartBtn')
  const removeBtns = document.querySelectorAll('#swym-remove-productBtn')

  //   Add to cart Btns
  for (let i = 0; i < addToCartButtons.length; i++) {
    addToCartButtons[i].addEventListener('click', onAddToCartClick, false)
    redirectButton[i].addEventListener('click', function () {
      window.location.href = redirectButton[i].attr('data-redirect-url')
    })
  }
  //   Remove Buttons
  for (let k = 0; k < removeBtns.length; k++) {
    removeBtns[k].addEventListener('click', onRemoveBtnClick, false)
  }
}

function initClickListeners(reRender = false) {
  const listsOptions = document.querySelectorAll('#Wishlists li')
  const selectedWishlist = document.querySelector('#selectedWishlist')
  const removeWishlist = document.querySelector('#removeList')

  for (let l = 0; l < listsOptions.length; l++) {
    const _listID = listsOptions[l].getAttribute('data-list-id')
    const _listName = listsOptions[l].innerText
    listsOptions[l].addEventListener(
      'click',
      function () {
        renderWishlistProducts(window._swat, _listID, _listName)
      },
      false,
      { once: true }
    )
  }

  if (!reRender) {
    selectedWishlist.addEventListener(
      'click',
      function (e) {
        if (['editList', 'removeList'].includes(e.target.id)) return
        // Toggle class
        if (this.classList.contains('list-expanded')) {
          this.classList.remove('list-expanded')
        } else {
          this.classList.add('list-expanded')
        }
      },
      false
    )

    removeWishlist.addEventListener('click', function (e) {
      // deleteList(selectedWishlist.getAttribute('data-list-id-shown'))
      renderModifyModal((modalOpen = true))
      selectedWishlist.classList.remove('list-expanded')
    })
    return
  }

  removeWishlist.innerHTML = 'Remove'
  return
}

function customWishlistFunction() {
  const getAllWishlistedProductInList = async (productID, listID) => {
    const _products = new Promise(function (getData) {
      window._swat.fetchListCtx({ lid: listID }, function (r) {
        getData(r)
      })
    })
    const products = await _products
    return products.filter((product) => product.empi === parseInt(productID))
  }

  const createNewList = async (listName) => {
    const _listData = new Promise(function (getID) {
      var newListDef = {
        lname: listName,
      }
      window._swat.createList(
        newListDef,
        function (newListObj) {
          getID(newListObj)
        },
        function (xhrObject) {
          console.log(xhrObject, 'xhrObject')
        }
      )
    })

    const listData = await _listData
    return listData
  }

  const getListData = async (listID) => {
    const _lists = new Promise(function (getLists) {
      window._swat.fetchLists({
        callbackFn: function (lists) {
          getLists(lists)
        },
        errorFn: function (xhrObj) {
          // something went wrong
        },
      })
    })

    const lists = await _lists
    return lists
  }

  const validateSelectors = async (productID) => {
    const selectedWishlistedID = $('#listSelector').val()
    const listInput = $('#newListInput')
    if (selectedWishlistedID === 'create-new') {
      listInput.removeClass('hidden')
      listInput.attr('disabled', false)
      const allList = await getAllListWishlist()

      $('#wishlistActionRemove').attr('data-wishlisted-quantity', 0)
      $('#wishlistActionAdd')
        .attr('data-wishlisted-quantity', 0)
        .text('Add to Wishlist')
      $('#wishlistedQuantity').text('').addClass('hidden')

      setTimeout(() => {
        listInput.focus()
      }, 0)

      $(listInput).on('keyup paste', function () {
        const _self = $(this)
        const hasMatched = allList
          .map((list) => list.lname)
          .some((list) => list.toLowerCase() === $(_self).val().toLowerCase())
        if (hasMatched) {
          $(listInput).addClass('list-exist')
          $('#wishlistActionAdd').attr('disabled', true)
          $('.error-msg').removeClass('hidden')
        } else {
          $(listInput).removeClass('list-exist')
          $('.error-msg').addClass('hidden')
          $('#wishlistActionAdd').attr('disabled', false)
        }
      })
    } else {
      renderQuantity(productID, selectedWishlistedID)
    }
  }

  const renderSelectionList = async (lid) => {
    const allLists = await getListData()
    $('#listSelector').empty()
    allLists.forEach((list) => {
      if (list.lid === lid) {
        $('#listSelector').append(
          `<option value="${list.lid}" selected>${list.lname}</option>`
        )
        return
      }
      $('#listSelector').append(
        `<option value="${list.lid}">${list.lname}</option>`
      )
    })
    $('#listSelector').append(`<option value="create-new">Create New</option>`)
  }

  const renderQuantity = async (productID, selectedWishlistedID) => {
    const listInput = $('#newListInput')
    const wishlisted = await getAllWishlistedProductInList(
      productID,
      selectedWishlistedID
    )
    const listData = await getListData(selectedWishlistedID)
    const selectedVariantID = parseInt($('#variantSelector').val())
    const existIndex = wishlisted.findIndex(
      (wl) => wl.epi === selectedVariantID && wl.lid === selectedWishlistedID
    )
    const listBelongs = listData.filter((list) =>
      list.listcontents.some(
        (listContent) => listContent.epi === selectedVariantID
      )
    )
    const listIDs = listBelongs.map((list) => list.lid)

    $(listInput).addClass('hidden')
    $(listInput).attr('disabled', true)

    if (listIDs.includes(selectedWishlistedID)) {
      $('#wishlistActionAdd').attr(
        'data-wishlisted-quantity',
        wishlisted[existIndex].qty
      )
      $('#wishlistActionRemove').attr(
        'data-wishlisted-quantity',
        wishlisted[existIndex].qty
      )
      $('#wishlistedQuantity').text(
        `Wishlisted Quantity: ${wishlisted[existIndex].qty}`
      )
      $('#wishlistedQuantity').removeClass('hidden')
    } else {
      $('#wishlistActionAdd').attr('data-wishlisted-quantity', 0)
      $('#wishlistActionRemove').attr('data-wishlisted-quantity', 0)
      $('#wishlistedQuantity').text('')
      $('#wishlistedQuantity').addClass('hidden')
    }
  }

  const listSelector = () => {
    const listOptionsLength = $('#listSelector option').length
    const listInput = $('#newListInput')
    const selectedList = $('#listSelector').val()

    if (selectedList === 'create-new' || listOptionsLength === 1) {
      listInput.removeClass('hidden')
      listInput.attr('disabled', false)
    } else {
      listInput.addClass('hidden')
      listInput.attr('disabled', true)
    }
  }

  const getAllListWishlist = async () => {
    const _lists = new Promise(function (getLists) {
      window._swat.fetchLists({
        callbackFn: function (lists) {
          getLists(lists)
        },
        errorFn: function (xhrObj) {
          // something went wrong
        },
      })
    })

    return _lists
  }
  const openWishlistModal = async (data, from = '', isJSON = false) => {
    $('#ProductModalWishlist').attr('data-status', 'open')

    const product = isJSON
      ? convertApiResponses(data)
      : JSON.parse(decodeURIComponent(data.replace(/\+/g, ' ')))
    $('#ProductModalWishlist').attr('data-product-id', product.id)

    const listsWishlist = await getAllListWishlist()
    const headerImage =
      typeof product.featured_image === 'object'
        ? product.featured_image.src
        : product.featured_image
    const headerImageAlt =
      typeof product.featured_image === 'object'
        ? product.featured_image.alt
        : product.featured_image.alt

    // If from PDP, variant ID automatically selected
    let selectedVariantID = ''

    if (from === 'pdp') {
      const queryString = window.location.search
      const urlParams = new URLSearchParams(queryString)
      selectedVariantID = parseInt(urlParams.get('variant'))
    }

    $('.wishlist-modal__content').append(`
    <div class="wishlist-modal__content--left">
      <div class="wishlist-modal__product-header">
        <div class="wishlist-modal__product-image">
          <a class="block aspect-square" href="${window.origin}/products/${
      product.handle
    }">
            <img class="w1" src="${headerImage}" alt="${headerImageAlt}">
          </a>
        </div>
        <div class="wishlist-modal__product-title">
          <p class="product-vendor">
            <a class="inline-link" href="${window.origin}/products/${
      product.handle
    }">
              ${product.vendor}
            </a>
          </p>
          <p class="product-title">
            <a class="inline-link" href="${window.origin}/products/${
      product.handle
    }">
              ${product.title}
            </a>
          </p>
        </div>
      </div>
    </div>

    <div class="wishlist-modal__content--right">
      <div class="wishlist-modal__product-selector">
        <div class="block w1 relative">
          <label for="lists-selector" class="block mb025">Lists</label>
          <div class="wishlist-modal__product-selector--list wishlist-modal__product-selector--select">
            <select name="selected-list" id="listSelector">
              ${listsWishlist.map((list) => {
                return `<option value="${list.lid}" >${list.lname}</option>`
              })}
              <option value="create-new">Create New List</option>
            </select>
            <input name="selected-list--input" id="newListInput" class="hidden">
          </div>
          <span class="create-new--error error-msg error__list-exist hidden">Wishlist exist</span>
        </div>

        <div class="block w1 relative">
          <label for="variant-selector" class="block mt075 mb025 ${
            product.variants.length === 1 ? 'hidden' : ''
          }">Variant</label>
          <div class="wishlist-modal__product-selector--variant wishlist-modal__product-selector--select ${
            product.variants.length === 1 ? 'hidden' : ''
          }">
            <select name="selected-variant" id="variantSelector">
              ${product.variants.map((variant) => {
                return `<option value="${variant.id}" ${
                  variant.id === selectedVariantID ? 'selected' : ''
                }>${variant.title}</option>`
              })}
            </select>
          </div>
        </div>

        <div class="wishlist-modal__product-selector--quantity">
          <label for="quantity-selector" class="block mt075 mb025">Quantity</label>
          <div class="selector-product-quantity">
            <button class="pointer selector-product-quantity-minus quantity-button quantity-bg-1 quantity-is-button quantity-bg-2 quantity-color-4" aria-label="Reduce Quantity">
              <span class="quantity-icon">-</span>
            </button>
            <div data-quantity-value="1" aria-label="Quantity selected is 1" id="quantitySelector" class="selector-product-quantity-value quantity-value">1</div>
            <button class="pointer selector-product-quantity-plus quantity-button quantity-bg-1 quantity-is-button quantity-bg-2 quantity-color-4" aria-label="Increase Quantity">
              <span class="quantity-icon">+</span>
            </button>
          </div>
        </div>
      </div>
      <span id="wishlistedQuantity" class="mt075"></span>
      <div class="wishlist-modal__product-cta">
        <hh-button-wrapper theme="primary" width='full' class="block mb025">
          <button
            id="wishlistActionAdd"
            ${
              from === 'pdp'
                ? ''
                : 'data-product-link="' +
                  window.origin +
                  '/products/' +
                  product.handle +
                  '"'
            }
            data-product-id="${product.id}"
            data-product-image="${
              typeof product.featured_image === 'object'
                ? product.featured_image.src
                : product.featured_image
            }"
            data-product-handle="${product.handle}"
          >
            Add to Wishlist
          </button>
        </hh-button-wrapper>
        <hh-button-wrapper theme="primary" width='full' class="block">
          <button
            id="wishlistActionRemove"
            data-product-id="${product.id}"
            ${
              from === 'pdp'
                ? ''
                : 'data-product-link="' +
                  window.origin +
                  '/products/' +
                  product.handle +
                  '"'
            }
            data-product-image="${
              typeof product.featured_image === 'object'
                ? product.featured_image.src
                : product.featured_image
            }"
            data-product-handle="${product.handle}"
          >
            Remove from Wishlist
          </button>
        </hh-button-wrapper>
        <p class="list-wishlists hidden"></p>
      </div>
    </div>
    `)

    listSelector()
    validateSelectors(product.id)
    quantityFunction()
    trapFocus($('#ProductModalWishlist'))
    initWishlistModalAction()
  }

  const trapFocus = (element) => {
    const focusableEls = $(element).find(
      'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])'
    )
    const firstFocusableEl = focusableEls[0]
    $(firstFocusableEl).trigger('focus')
    const lastFocusableEl = focusableEls[focusableEls.length - 1]
    const KEYCODE_TAB = 9

    $(element).on('keydown', function (e) {
      var isTabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB

      if (!isTabPressed) {
        return
      }

      if (e.shiftKey) {
        /* shift + tab */ if (document.activeElement === firstFocusableEl) {
          lastFocusableEl.focus()
          e.preventDefault()
        }
      } /* tab */ else {
        if (document.activeElement === lastFocusableEl) {
          firstFocusableEl.focus()
          e.preventDefault()
        }
      }
    })
  }

  const fetchProductTags = (productHandle) => {
    return new Promise((resolve) => {
      jQuery.getJSON(
        window.Shopify.routes.root + 'products/' + productHandle + '.js',
        function (product) {
          resolve(product.tags || [])
        }
      )
    })
  }

  const showCustomNotification = (
    ctaAction = 'add',
    listID,
    listName,
    productData
  ) => {
    let customNotification = ''

    if (productData.hasError) {
      customNotification = `
      <div class="toast--wrapper">
        <a class="toast__image" href="#"></a>
        <div class="toast__content mt-2">
          <h2 class="toast__content__title">Error!</h2>
          <p class="toast__content__product-name">${productData.msg}</p>
        </div>
      </div>`
    } else {
      const actionText =
        ctaAction === 'update'
          ? 'Product updated'
          : `${
              ctaAction === 'add' ? 'Added' : 'Removed'
            } to Wishlist: ${listName}`

      customNotification = `
      <div class="toast--wrapper">
        <a class="toast__image" href="${productData.du}">
          <img alt="Image" class="w1 rounded mr-2 img-thumbnail" src="${productData.iu}">
        </a>
        <div class="toast__content mt-2">
          <h2 class="toast__content__title">${actionText} to Wishlist: ${listName}</h2>
          <p class="toast__content__manufacture-name">${productData.bt}</p>
          <p class="toast__content__product-name">${productData.dt}</p>
          <a class="toast__content--cta" href="#" id="openWl" data-list-name="${listName}" data-list-id="${listID}">View Wishlist</a>
        </div>
      </div>`
    }

    toastr.options = {
      closeButton: true,
      debug: false,
      newestOnTop: false,
      progressBar: true,
      positionClass: 'toast-top-left',
      preventDuplicates: false,
      showDuration: '30000',
      hideDuration: '100000',
      timeOut: '100000',
      extendedTimeOut: '100000',
      showEasing: 'swing',
      hideEasing: 'linear',
      showMethod: 'slideDown',
      hideMethod: 'slideUp',
      onShown: function () {
        notificationShown()
      },
      onHidden: function () {
        notificationHidden()
      },
    }

    toastr['success'](customNotification)

    bindEvent()
    function bindEvent() {
      const openWishlist = document.getElementById('openWl')
      if (openWishlist) {
        openWishlist.onclick = function () {
          // swat.ui.open();

          $('#ProductModalWishlistLists').attr('data-status', 'open')
          $('body').addClass('wishlist-modal-opened')
          window.SwymCallbacks.push(swymRenderWishlist)
          closeWishlistModal()
        }
      }
    }

    function notificationShown() {
      $('body').addClass('toastr-notification--shown')
      trapFocus($('#toast-container'))
    }

    function notificationHidden() {
      $('body').removeClass('toastr-notification--shown')
      trapFocus($('#ProductModalWishlist'))
    }

    function getVariantInfo(variants) {
      try {
        let variantKeys =
            variants && variants != '[]' ? Object.keys(variants[0]) : [],
          variantinfo
        if (variantKeys.length) {
          variantinfo = variantKeys[0]
        }
        return variantinfo == 'Default Title' ? '' : variantinfo
      } catch (err) {
        return variants
      }
    }
  }

  const addRequest = async (
    swat,
    _self,
    variantID,
    productID,
    productImage,
    productHandle,
    productQuantity,
    listID,
    listName,
    tags,
    ctaAction
  ) => {
    swat.addToList(
      listID,
      {
        epi: variantID,
        du: window.location.origin + '/products/' + productHandle,
        empi: productID,
        iu: productImage,
        qty: productQuantity,
        cprops: {
          tags: tags,
        },
      },
      function (r) {
        var listItemMap = {
          epi: variantID,
          du: window.location.origin + '/products/' + productHandle,
          empi: productID,
          iu: productImage,
          qty: productQuantity,
        }

        _self.updateListItem(
          listID,
          listItemMap,
          function (updatedListItem) {
            delete updatedListItem.SETTINGS
            delete updatedListItem.STRINGS

            renderWishlistIcons()
            showCustomNotification(ctaAction, listID, listName, updatedListItem)
            renderQuantity(productID, listID)
            renderSelectionList(listID)
            // callback(updatedListItem);
          },
          function (xhrObj) {
            console.log(xhrObj)
          }
        )
      },
      function (xhrObj) {
        // something went wrong
        console.log(xhrObj, 'xhrObj addToList')
      }
    )
  }

  const swymWishlistAction = async (
    ctaAction = 'add',
    productID,
    productImage,
    productHandle,
    productWishlistedQuantity = 0
  ) => {
    // const variantID = parseInt($('#variantSelector').val())
    const variantID = document
      .getElementById('variantSelector')
      .value.replace('gid://shopify/ProductVariant/', '')
    const productQuantity = parseInt(
      $('#quantitySelector').attr('data-quantity-value')
    )
    const listSelector = $('#listSelector').val()
    const tags = await fetchProductTags(productHandle)
    async function swymCallbackFn(swat) {
      const _self = swat

      let listID = listSelector
      let listName = $('#listSelector :selected').text()
      if (listSelector === 'create-new') {
        const inputListName = $('#newListInput').val()
        const listData = await createNewList(inputListName)

        listID = listData.lid
        listName = listData.lname
      }

      if (ctaAction === 'add') {
        const qty = productQuantity + parseInt(productWishlistedQuantity)
        addRequest(
          swat,
          _self,
          variantID,
          productID,
          productImage,
          productHandle,
          qty,
          listID,
          listName,
          tags,
          ctaAction
        )
      } else {
        const listItemMap = {
          epi: variantID, // unique epi per listid
          empi: productID,
          du: window.location.origin + '/products/' + productHandle,
        }

        const currentQuantity =
          parseInt(productWishlistedQuantity) - productQuantity
        if (currentQuantity <= 0) {
          swat.deleteFromList(
            listSelector,
            listItemMap,
            function (deletedListItem) {
              // successfully deleted list item
              showCustomNotification(
                'remove',
                listID,
                listName,
                deletedListItem
              )
              renderQuantity(productID, listSelector)
            },
            function (xhrObj) {
              console.log(xhrObj, 'delete Error')
            }
          )
        } else {
          const ctaAction = currentQuantity === 0 ? 'remove' : 'update'
          addRequest(
            swat,
            _self,
            variantID,
            productID,
            productImage,
            productHandle,
            currentQuantity,
            listID,
            listName,
            tags,
            ctaAction
          )
        }
      }
    }
    if (!window.SwymCallbacks) {
      window.SwymCallbacks = []
    }
    window.SwymCallbacks.push(swymCallbackFn)
  }

  const closeWishlistModal = () => {
    $('#ProductModalWishlist').attr('data-status', 'close')
    $('#ProductModalWishlist .wishlist-modal__content').empty()
  }

  const quantityFunction = () => {
    $('.selector-product-quantity-plus').on('click', function () {
      const oldVal = parseInt(
        $('#quantitySelector').attr('data-quantity-value')
      )
      const newVal = oldVal + 1
      $('#quantitySelector').attr('data-quantity-value', newVal)
      $('#quantitySelector').attr(
        'aria-label',
        'Quantity selected is ' + newVal
      )
      $('#quantitySelector').text(newVal)
    })

    $('.selector-product-quantity-minus').on('click', function () {
      const oldVal = parseInt(
        $('#quantitySelector').attr('data-quantity-value')
      )
      let newVal
      if (oldVal > 1) {
        newVal = oldVal - 1
      } else {
        newVal = 1
      }

      $('#quantitySelector').attr('data-quantity-value', newVal)
      $('#quantitySelector').attr(
        'aria-label',
        'Quantity selected is ' + newVal
      )
      $('#quantitySelector').text(newVal)
    })
  }

  const initWishlistModalAction = () => {
    $('#listSelector, #variantSelector').on('change', function () {
      const productID = $(this)
        .closest('#ProductModalWishlist')
        .attr('data-product-id')
      validateSelectors(productID)
    })

    $('#CloseWishlistModal, .wishlist-modal--bg').on('click', function () {
      closeWishlistModal()
    })

    $('#wishlistActionAdd').on('click', function () {
      const productID = $(this).attr('data-product-id')
      const productImage = $(this).attr('data-product-image')
      const productHandle = $(this).attr('data-product-handle')
      const productWishlistedQuantity =
        $(this).attr('data-wishlisted-quantity') || 0
      const productLink = $(this).attr('data-product-link')

      swymWishlistAction(
        'add',
        productID,
        productImage,
        productHandle,
        productWishlistedQuantity
      )
    })

    $('#wishlistActionRemove').on('click', function () {
      const productID = $(this).attr('data-product-id')
      const productImage = $(this).attr('data-product-image')
      const productHandle = $(this).attr('data-product-handle')
      const productWishlistedQuantity =
        $(this).attr('data-wishlisted-quantity') || 0

      swymWishlistAction(
        'remove',
        productID,
        productImage,
        productHandle,
        productWishlistedQuantity
      )
    })
  }

  const convertApiResponses = (data) => {
    const productNode = data
    if (!productNode) return null

    let product = {}

    product.id = productNode.id
    product.title = productNode.title
    product.vendor = productNode.vendor
    product.handle = productNode.handle

    if (productNode.images.edges.length > 0) {
      product.featured_image = {
        src: productNode.images.edges[0].node.originalSrc,
        alt: productNode.images.edges[0].node.altText,
      }
    } else {
      product.featured_image = null
    }

    product.variants = productNode.variants.edges.map((edge) => {
      return {
        id: edge.node.id,
        title: edge.node.title,
      }
    })

    return product
  }

  const initWishlist = () => {
    $('.product-wishlist--button')
      .on('click', function () {
        $(this).addClass('pulse')

        const productId = $(this).attr('data-product-id')
        if (!productId) {
          $(this).removeClass('pulse')
          return
        }

        fetchProductData(productId).then((productData) => {
          if (!productData) return

          openWishlistModal(productData, 'collection', true)
          $(this).removeClass('pulse')
        })
      })
      .on('focus', function () {
        $(this).addClass('is-active', '1')
      })
      .on('blur', function () {
        $(this).removeClass('is-active', '0')
      })
  }

  const fetchProductData = (productId) => {
    return fetch('https://ctrl-mod.myshopify.com/api/2023-07/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/graphql',
        'X-Shopify-Storefront-Access-Token': window.__GLOBAL__.storefront,
      },
      body: `
        {
          product(id: "gid://shopify/Product/${productId}") {
            id
            title
            handle
            vendor
            images(first: 1) {
              edges {
                node {
                  originalSrc
                  altText
                }
              }
            }
            variants(first: 50) {
              edges {
                node {
                  id
                  title
                }
              }
            }
          }
        }
      `,
    })
      .then((response) => response.json())
      .then((data) => {
        if (!data.data.product) return

        data.data.product.id = productId
        return data.data.product
      })
      .catch((error) => console.error('Error:', error))
  }

  const renderWishlistIcons = () => {
    window._swat.fetch(function (wishlistProducts) {
      const products = wishlistProducts.map((product) => {
        return product.empi
      })

      $('#bc-sf-filter-products > .bc-sf-filter-product-item').each(function (
        index
      ) {
        const productID = parseInt(
          $(this).find('.product-wishlist--button').attr('data-product-id')
        )
        if (products.includes(productID)) {
          $(this).find('.product-wishlist--button').addClass('swym-added')
        }
      })
    })
  }

  // PDP
  const initPDPWishlist = async () => {
    if (window.meta.page.pageType !== 'product') return
    const productID = $('#SwymPDPAction').attr('data-product-id')

    $('#SwymPDPAction').on('click', function () {
      $(this).addClass('pulse')

      const productId = $(this).attr('data-product-id')
      if (!productId) {
        $(this).removeClass('pulse')
        return
      }

      fetchProductData(productId).then((productData) => {
        if (!productData) return

        openWishlistModal(productData, 'pdp', true)
        $(this).removeClass('pulse')
      })
    })
  }

  jQuery(function () {
    const swatInterval = setInterval(function () {
      if (typeof window._swat !== 'undefined') {
        initWishlist()
        initPDPWishlist()
        clearInterval(swatInterval)
      }
    }, 500)
  })
}

window.addEventListener('load', (event) => {
  const windowSwatAPI = setInterval(function () {
    if (typeof window._swat !== 'undefined') {
      const queryParams = window._swat.utils.getEncodedAsObject(
        window.location.search
      )
      const sharedHkey = queryParams['hkey'] || queryParams['lid']

      if (
        typeof queryParams['swaction'] !== 'undefined' &&
        typeof sharedHkey !== 'undefined'
      ) {
        document
          .querySelector('#ProductModalWishlistLists')
          .setAttribute('data-status', 'open')
        document.querySelector('body').classList.add('wishlist-modal-opened')
        swymRenderWishlist(
          window._swat,
          false,
          (fromSharedWishlist = true),
          (sharedListID = sharedHkey),
          (page = false)
        )
      } else if (typeof sharedHkey !== 'undefined') {
        swymRenderWishlist(
          window._swat,
          false,
          (fromSharedWishlist = true),
          (sharedListID = sharedHkey),
          (page = true)
        )
      }
      clearInterval(windowSwatAPI)
    }
  }, 500)
  customWishlistFunction()
})

window.customWishlistFunction = customWishlistFunction

function addWishlistEventListeners() {
  const ProductModalWishlistLists = document.querySelector(
    '#ProductModalWishlistLists'
  )
  function handleAction(event) {
    if (
      event.type === 'keydown' &&
      event.key !== 'Enter' &&
      event.keyCode !== 13
    )
      return

    ProductModalWishlistLists.setAttribute('data-status', 'open')
    document.body.classList.add('wishlist-modal-opened')
    window.SwymCallbacks.push(swymRenderWishlist)
  }

  document.querySelectorAll('.js-trigger-wishlist-modal').forEach((element) => {
    element.addEventListener('click', handleAction)
    element.addEventListener('keydown', handleAction)
  })
}

document.addEventListener('DOMContentLoaded', function () {
  addWishlistEventListeners()
})
